import axios from "axios"
import { mainApi } from "../api/root-api"
import { loadingAccounts, loadingError, successAccounts, newAccount, removeAccount, updateAccounts } from "../slices/accountsSlice"
import { setAccount } from "../slices/orderSlice"
import { setError, setSuccess } from "../slices/statusSlice"

const accountsRoute = 'accounts'

export const getAccountsAction = ( token ) => {
  return async( dispatch, getState ) => {
    let payload = {}
    dispatch(loadingAccounts())
    await mainApi.get(accountsRoute, { headers: {Authorization: token} }).then(resp => {
      dispatch(successAccounts(resp.data))
      payload = {
        message: 'Cuentas cargadas con éxito',
        status: resp.status
      }  
      // dispatch(setSuccess(payload))  
    }).catch(err => {
      payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }  
      dispatch( setError(payload) )
    })
  }
}

export const newAccountAction = (form, token) => {
  // const {
  // value,
  // street,
  // extNumber,
  // intNumber,
  // colony,
  // postalCode,
  // state,
  // city,
  // country,
  // type,
  // reference,
  // name,
  // receiver,
  // defaultAddressInvoice,
  // latitude,
  // longitude,
  // addressType} = form 
  // let newForm = {
  //   name, type, receiver, 
  //   address: {
  //     street, extNumber, intNumber, postalCode, colony, latitude, longitude, reference 
  //   }
  // }
  const headers = { headers: { Authorization: token } }
  
  return async ( dispatch, getState ) => {
    await mainApi.post(accountsRoute, form, headers).then(resp => {
      const payload = {
        status: resp.status,
        message: 'Cuenta creada con exito'
      }
      dispatch(newAccount(resp.data))
      // dispatch(setSuccess(payload))
      dispatch(setAccount(resp.data))
      return resp
    }).catch(err => {
      
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch(setError(payload))
      return err
    })
  }
}

export const editAccountAction =(form, id, token) => {
  const newUrl = `${accountsRoute}/${id}`
  
  return async (dispatch) => {
    await mainApi.put(newUrl, form, { headers: { authorization: token } }).then(resp => {
      
      const payload = {
        status: resp.status,
        message: 'Se Actualizo correctamente'
      }
      dispatch(setSuccess(payload))
      
      dispatch(updateAccounts({...resp.data, type: form.type}))
      
      return resp
    }).catch(err => {
      
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch(setError(payload))
      return err
    })
  }
}

export const deleteAccount = ( id, token ) => {
  const headers = { headers: { Authorization: token } }

  return async (dispatch) => {
    await mainApi.delete(`${accountsRoute}/${id}`, headers).then(resp => {
      
      const payload = {
        status: resp.status,
        message: resp.data.message
      }
      dispatch(setSuccess(payload))
      dispatch(removeAccount({id, all:true}))
    }).catch(err => {
      const payload = {
        message: err.response.data.message.error,
        status: err.response.status
      }
      dispatch(setError(payload))
    })
  }
}